import React from 'react';
import { Link } from 'react-router-dom';

const Iot = () => {
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <p>Our Services</p>
            <h2>Custom IoT Software Development</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
  {/* breadcrumb-banner-area-end */}
  <div className="container">
    <div className="row mb-5">
      <div className="col-sm-12 col-lg-7 align-self-center">
        <div>
          <p>Techarabiya renders internet of things development services, delivering custom apps that harness the power of connected devices to advance lifestyles and empower enterprises with next-generation IoT products.</p>
          <p>At Techarabiya, we specialize in building large-scale Enterprise IoT 
            solutions specifically for Retail, Insurance and Banking &amp; Finance 
            Industry. </p>
          <p>We offers full range of Internet of Things services. We work at mobile, web, data and embedded levels to align with all your tech needs 
            whether you have just one part of an IoT puzzle missing or require a full-scale solution. 
          </p>
          <p>It includes smooth app-to-device communication, mobile data 
            visualization, alert messaging, face recognition technologies, 
            connectivity protocols, machine learning algorithms, voice control 
            interfaces and many more.
          </p>
        </div>
      </div>
      <div className="col-sm-12 col-lg-5">
        <img src="./img/iot2.png" className="img-fluid" />
      </div>
    </div>
  </div>
  <div className="container-fluid aboutus-service">
    <div className="container">
      <div className="row mb-5">
        <div className="col-sm-12 col-lg-6">
          <img src="./img/iot.png" className="img-fluid" />
        </div>
        <div id="ecommerce" className="col-sm-12 col-lg-6 align-self-center">
          <div className="style-ecommerce">
            <h3><b>We empower organizations to:</b></h3>
            <br />
            <ul className="list-check list-unstyled list">
              <li><i className="far fa-check-circle" />Connect and scale with efficiency.
              </li>
              <li> <i className="far fa-check-circle" />Analyze and Act on new data.
              </li>
              <li><i className="far fa-check-circle" />Integrate and transform business processes.</li>
              <li><i className="far fa-check-circle" />Improve decision making with augmented intelligence.
              </li>
              <li><i className="far fa-check-circle" />Design, develop, integrate, deploy and manage 
                end-to-end IoT processes.</li>
              <li> <i className="far fa-check-circle" />Seamlessly integrate IoT solutions with existing enterprise 
                architecture</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="container padding-top">
    <div className="row mb-5">
      <div className="col-sm-12 col-lg-6 align-self-center">
        <h2><b>Services We Offer</b></h2>
        <hr />
        <ul className="list-check list-unstyled list">
          <li><i className="far fa-check-circle" />Consulting &amp; Solution Development
          </li>
          <li> <i className="far fa-check-circle" />IOT Platform</li>
          <li><i className="far fa-check-circle" />Connected Device</li>
          <li><i className="far fa-check-circle" />Vertical Application</li>
          <li><i className="far fa-check-circle" />End-to-End System Integration</li>
        </ul>
      </div>
      <div className="col-sm-12 col-lg-6">
        <img src="./img/iot3.png" className="img-fluid" />
      </div>
    </div>
  </div>
  {/*- Contact Us bar */}
  <div className="container contactus">
  <div className="row mb-5">
    <div className="col-lg-8 col-sm-12 align-self-center">
		<div className="d-flex justify-content-center">
		<span className="contact-text">Are you ready to work with us? Get in touch now!</span>
		</div>
    
    </div>
    <div className="col-lg-4 col-sm-12 align-self-center">
      <div className="d-flex justify-content-center">
		 <Link to="/ContactUs" className="contact-button"> CONTACT US NOW </Link>
      </div>
    </div>
  </div>
</div>
</div>
  </div>
    )
}

export default Iot
